export const OfferStateCodesForSignatureCancellation = 'OfferStateCodesForSignatureCancellation';
export const BankTypeId = 'BankTypeId';